import { render, staticRenderFns } from "./purchaseAgreementCreation.vue?vue&type=template&id=2180902a&scoped=true"
import script from "./purchaseAgreementCreation.vue?vue&type=script&lang=js"
export * from "./purchaseAgreementCreation.vue?vue&type=script&lang=js"
import style0 from "./purchaseAgreementCreation.vue?vue&type=style&index=0&id=2180902a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180902a",
  null
  
)

export default component.exports